(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gg-matvalet-compass"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gg-matval')) {
  customElements.define('gg-matval', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const config = this.querySelector('[data-config]');
      if (!config) return;
      this.ready = true;
      this.c = JSON.parse(config.textContent);
      this.answers = Array(this.c.questions.length).fill(null);
      this.weights = Array(this.c.questions.length).fill(1);
      this.index = 0;
      this.onClick = event => {
        const shop=event.target.closest('[data-result-shop]');if(shop&&this.contains(shop)){this.updateRewardUI();return;}
        const b = event.target.closest('button');
        if (!b || !this.contains(b)) return;
        if (b.hasAttribute('data-answer')) this.answer(Number(b.dataset.answer));
        else if (b.hasAttribute('data-back') && this.index > 0) { this.index--; this.render(true); }
        else if (b.hasAttribute('data-skip')) { this.answers[this.index]=null; this.next(); }
        else if (b.hasAttribute('data-next') && this.answers[this.index]!==null) this.next();
        else if (b.hasAttribute('data-restart')) { this.code=null; this.answers.fill(null); this.weights.fill(1); this.index = 0; this.render(true); }
        else if (b.hasAttribute('data-share')) this.share();
        else if (b.hasAttribute('data-open-envelope')) this.openEnvelope();
        else if (b.hasAttribute('data-copy-code')) this.copy(this.code, this.el('code-status'), true);
      };
      this.addEventListener('click', this.onClick);
      this.el('important').addEventListener('change', event => { this.weights[this.index] = event.target.checked ? 2 : 1; });
      this.onBlockSelect=event=>{const i=this.c.questions.findIndex(q=>q.id===event.detail.blockId);if(i>=0){this.index=i;this.render(true);}};
      this.addEventListener('shopify:block:select',this.onBlockSelect);

      this.syncCampaignCopy();
      this.campaignTimer=setInterval(()=>{this.syncCampaignCopy();if(!this.el("result-panel").hidden)this.updateRewardUI();},15000);
      this.sectionLoaded=()=>this.syncCampaignCopy();document.addEventListener("shopify:section:load",this.sectionLoaded);
      this.buildMethod();
      this.render(false);
    }
    disconnectedCallback(){clearInterval(this.campaignTimer);document.removeEventListener("shopify:section:load",this.sectionLoaded);this.removeEventListener('click',this.onClick);this.removeEventListener('shopify:block:select',this.onBlockSelect);this.ready=false;}
    el(key) { return this.querySelector('[data-' + key + ']'); }
    label(key) { return this.c.labels[key]; }
    fill(key, args) { return Object.entries(args).reduce((s,[k,v]) => s.replaceAll('{' + k + '}', String(v)), this.label(key)); }
    buildMethod() {
      const host = this.el('method');
      const p = document.createElement('p'); p.textContent = this.label('scale'); host.append(p);
      const table = document.createElement('table');
      const caption = document.createElement('caption'); caption.textContent = this.label('profile'); table.append(caption);
      const head = document.createElement('thead'); const tr = document.createElement('tr');
      [this.label('profile'),...this.c.questions.map((_,i) => String(i+1))].forEach(text => { const th = document.createElement('th'); th.scope='col'; th.textContent=text; tr.append(th); });
      head.append(tr); table.append(head);
      const body = document.createElement('tbody');
      this.c.profiles.forEach(profile => { const row=document.createElement('tr'); const title=document.createElement('th'); title.scope='row';title.textContent=profile.name;row.append(title);profile.points.forEach(point=>{const td=document.createElement('td');td.textContent=point;row.append(td);});body.append(row); });
      table.append(body);host.append(table);
      const list=document.createElement('ol');this.c.questions.forEach(q=>{const li=document.createElement('li');li.textContent=q.text;list.append(li);});host.append(list);
    }
    render(focus) {
      this.el('result-panel').hidden = true;
      this.el('question-panel').hidden = false;
      const q=this.c.questions[this.index];
      if(!q){this.result();return;}
      this.querySelector('progress').max=this.c.questions.length;
      this.el('step').textContent=this.fill('step',{n:this.index+1,total:this.c.questions.length});
      this.querySelector('progress').value=this.index;
      const heading=this.el('question');
      heading.classList.toggle('mv-heading-gg',q.font==='gg');
      heading.toggleAttribute('data-mv-size',q.size>0);
      heading.toggleAttribute('data-mv-mobile-size',q.mobile>0);
      heading.style.setProperty('--mv-title-size',(q.size||0)+'px');
      heading.style.setProperty('--mv-title-mobile',(q.mobile||0)+'px');
      heading.style.setProperty('--mv-title-tracking',Math.max(-100,Math.min(500,q.tracking??20))/1000+'em');
      heading.textContent=q.text;
      this.el('help').textContent=q.help;
      this.el('important').checked=this.weights[this.index]===2;
      this.el('back').disabled=this.index===0;
      const options=this.querySelector('.mv-answers'); options.replaceChildren();
      for(let i=0;i<4;i++){const b=document.createElement('button');b.type='button';b.className='mv-answer';b.dataset.answer=i;b.textContent=q.answers[i];if(this.answers[this.index]===i){const mark=document.createElement('span');mark.className='ggicon';mark.setAttribute('aria-hidden','true');mark.textContent='Q';b.append(mark);}b.setAttribute('aria-pressed',String(this.answers[this.index]===i));options.append(b);}
      const selected=this.answers[this.index]!==null;
      this.el('next').disabled=!selected;this.el('next').textContent=this.label(this.index===this.c.questions.length-1?'finish':'next');
      this.el('selection-status').textContent=selected?this.label('selected'):'';
      this.el('learning').hidden=!selected || !q.explanation;this.el('explanation').textContent=selected?q.explanation:'';
      if(focus){this.el('question').focus({preventScroll:true});this.el('question-panel').scrollIntoView({block:'start',behavior:'auto'});}
    }
    answer(value) {
      this.answers[this.index]=value;
      this.render(false);
      const selected=this.querySelector('[data-answer="'+value+'"]');if(selected)selected.focus({preventScroll:true});
    }
    next() {
      this.index++;
      if(this.index<this.c.questions.length)this.render(true);else this.result();
    }
    result() {
      const count=this.answers.filter(a=>a!==null).length;
      this.el('question-panel').hidden=true;this.el('result-panel').hidden=false;
      this.el('results').replaceChildren();this.el('share-status').textContent='';
      this.el('result-context').textContent=this.fill('context',{n:count,total:this.c.questions.length});
      const scores=this.c.profiles.map((p,i)=>{
        let difference=0,total=0;
        this.answers.forEach((a,j)=>{if(a!==null){difference+=Math.abs(a-p.points[j])*this.weights[j];total+=this.weights[j];}});
        return {...p,id:i,score:total?Math.round(100*(1-difference/(3*total))):0};
      }).sort((a,b)=>b.score-a.score);
      this.scores=scores;this.code=null;
      this.ggScore=scores.find(p=>p.id===0)?.score||0;
      this.tier=this.c.tiers.filter(t=>this.ggScore>=t.threshold).sort((a,b)=>b.discount-a.discount)[0]||this.c.tiers[0];
      const winners=count?scores.filter(p=>p.score===scores[0].score):[];
      this.el('result-title').textContent=!count?this.label('none_title'):winners.length>1?this.label('tie_title'):scores[0].title;
      this.el('result-description').textContent=!count?this.label('none_description'):winners.length>1?this.label('tie_description')+' '+winners.map(p=>p.name).join(' · '):scores[0].description;
      if(count)scores.forEach(p=>{const row=document.createElement('div');row.className='mv-result-row';row.style.setProperty('--mv-profile-color','var(--mv-profile-'+p.id+')');const line=document.createElement('div');const name=document.createElement('span');name.textContent=p.name;const percent=document.createElement('span');percent.textContent=p.score+' %';line.append(name,percent);const bar=document.createElement('div');bar.className='mv-bar';bar.setAttribute('aria-hidden','true');const fill=document.createElement('span');fill.style.width=p.score+'%';bar.append(fill);row.append(line,bar);this.el('results').append(row);});
      const important=this.c.questions.filter((_,i)=>this.weights[i]===2 && this.answers[i]!==null).map(q=>q.text);
      this.el('result-reasons').textContent=count?(important.length?this.label('reason')+important.join(' '):this.label('no_reason')):'';
      this.el('share').hidden=!count;
      this.el('reward').hidden=true;this.el('open-envelope').hidden=false;this.el('code-status').textContent='';
      this.updateRewardUI();
      this.el('result-title').focus({preventScroll:true});this.el('result-panel').scrollIntoView({block:'start',behavior:'auto'});
    }
    campaignPhase(now=Date.now()) {
      const start=Date.parse(this.c.starts),end=Date.parse(this.c.ends);
      if(this.c.rewardMode!=='active'||!Number.isFinite(start)||!Number.isFinite(end)||start>=end)return 'off';
      return now<start?'before':now>=end?'after':'active';
    }
    syncCampaignCopy(){const phase=this.campaignPhase();document.querySelectorAll('[data-mv-campaign-copy]').forEach(el=>{const text=el.dataset[phase==='off'?'after':phase]||el.dataset.after;if(text&&el.textContent!==text)el.textContent=text;});}
    discountText(key){return this.c.campaignCopy[key].replaceAll('{discount}',String(this.tier.discount));}
    updateRewardUI(){
      const available=this.rewardAvailable(),phase=this.campaignPhase();
      const shop=this.el('result-shop');
      this.el('envelope').hidden=!available;
      shop.textContent=available?this.discountText('shop_discount'):this.c.campaignCopy.shop;
      shop.href='#matval-produkter';
      if(available){
        const code=this.codes()[0];const destination=new URL(location.href);destination.hash='matval-produkter';
        const redirect=destination.pathname+destination.search+destination.hash;
        shop.href='/discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent(redirect);
        this.el('reward-title').textContent=this.discountText('title');
        this.el('envelope-intro').textContent=this.c.campaignCopy.intro;
      }else{this.el('reward').hidden=true;this.code=null;}
      this.el('reward-note').textContent=phase!=='active'?this.c.campaignCopy[phase]:this.answers.some(a=>a===null)?this.label('incomplete'):available?(this.tier.discount===25?this.c.campaignCopy.highest:this.c.campaignCopy.replay):this.c.campaignCopy.off;
    }
    rewardAvailable() {
      if(!this.c.questions.length || this.answers.some(a=>a===null))return false;
      if(this.c.rewardMode==='preview')return true;
      if(this.c.rewardMode!=='active')return false;
      const start=Date.parse(this.c.starts),end=Date.parse(this.c.ends),now=Date.now();
      return this.codes().length>0 && Boolean(this.c.terms?.trim()) && Number.isFinite(start) && Number.isFinite(end) && start<end && now>=start && now<end;
    }
    codes(){return (this.tier?.codes||'').split(/\r?\n/).map(s=>s.trim()).filter(Boolean);}
    openEnvelope() {
      if(!this.rewardAvailable()){this.el('envelope-intro').textContent=this.label('expired');this.el('open-envelope').hidden=true;return;}
      const demo=this.c.rewardMode==='preview';
      if(!demo && !this.code){const pool=this.codes();const random=new Uint32Array(1);crypto.getRandomValues(random);this.code=pool[Math.floor((random[0]/4294967296)*pool.length)];}
      this.el('code-label').textContent=demo?'':this.label('code_label');
      this.el('code').textContent=demo?this.fill('demo_code',{discount:this.tier.discount}):this.code;
      this.el('terms').textContent=demo?this.label('demo_terms'):this.c.terms;
      this.el('copy-code').hidden=demo;
      this.el('reward').hidden=false;this.el('open-envelope').hidden=true;
    }
    async copy(text,status,isCode=false) {
      try { await navigator.clipboard.writeText(text);status.textContent=this.label(isCode?'copied_code':'copied'); }
      catch { status.textContent=this.label('copy_fail')+' '+text; }
    }
    async share() {
      const winners=this.scores.filter(p=>p.score===this.scores[0].score);
      const text=this.fill('share_text',{name:winners.map(p=>p.name).join(' / '),score:this.scores[0].score});
      const url=new URL(location.href);url.hash='matval-kompass';
      if(url.searchParams.get('view')==='matvalet')url.searchParams.set('preview_theme_id',this.c.themeId);
      for(const key of [...url.searchParams.keys()])if(!['preview_theme_id','view'].includes(key))url.searchParams.delete(key);
      if(navigator.share){try{await navigator.share({title:'Gröna gårdar · Matvalet 2026',text,url:url.href});return;}catch(e){if(e.name==='AbortError')return;}}
      await this.copy(text+' '+url.href,this.el('share-status'));
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gg-matvalet-products"] && !Shopify.designMode) return;
  try {
    
function initMatvalProducts(root=document){root.querySelectorAll('.mv-products').forEach(section=>{const button=section.querySelector('[data-mv-expand-products]');if(!button||button.dataset.ready)return;button.dataset.ready='true';const extra=Array.from(section.querySelectorAll('[data-mv-extra-product]'));extra.forEach(item=>item.hidden=true);button.hidden=extra.length===0;button.addEventListener('click',()=>{const next=extra.filter(item=>item.hidden).slice(0,24);next.forEach(item=>item.hidden=false);button.hidden=!extra.some(item=>item.hidden);if(button.hidden&&next.length){const link=next[0].querySelector('a');if(link)link.focus({preventScroll:true});}});});}
initMatvalProducts();document.addEventListener('shopify:section:load',e=>initMatvalProducts(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gg-matvalet"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gg-matval')) {
  customElements.define('gg-matval', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const config = this.querySelector('[data-config]');
      if (!config) return;
      this.ready = true;
      this.c = JSON.parse(config.textContent);
      this.answers = Array(this.c.questions.length).fill(null);
      this.weights = Array(this.c.questions.length).fill(1);
      this.index = 0;
      this.onClick = event => {
        const b = event.target.closest('button');
        if (!b || !this.contains(b)) return;
        if (b.hasAttribute('data-answer')) this.answer(Number(b.dataset.answer));
        else if (b.hasAttribute('data-back') && this.index > 0) { this.index--; this.render(true); }
        else if (b.hasAttribute('data-skip')) this.answer(null);
        else if (b.hasAttribute('data-restart')) { this.answers.fill(null); this.weights.fill(1); this.index = 0; this.render(true); }
        else if (b.hasAttribute('data-share')) this.share();
        else if (b.hasAttribute('data-open-envelope')) this.openEnvelope();
        else if (b.hasAttribute('data-copy-code')) this.copy(this.code, this.el('code-status'), true);
      };
      this.addEventListener('click', this.onClick);
      this.el('important').addEventListener('change', event => { this.weights[this.index] = event.target.checked ? 2 : 1; });
      this.buildMethod();
      this.render(false);
    }
    el(key) { return this.querySelector('[data-' + key + ']'); }
    label(key) { return this.c.labels[key]; }
    fill(key, args) { return Object.entries(args).reduce((s,[k,v]) => s.replaceAll('{' + k + '}', String(v)), this.label(key)); }
    buildMethod() {
      const host = this.el('method');
      const p = document.createElement('p'); p.textContent = this.label('scale'); host.append(p);
      const table = document.createElement('table');
      const caption = document.createElement('caption'); caption.textContent = this.label('profile'); table.append(caption);
      const head = document.createElement('thead'); const tr = document.createElement('tr');
      [this.label('profile'),...this.c.questions.map((_,i) => String(i+1))].forEach(text => { const th = document.createElement('th'); th.scope='col'; th.textContent=text; tr.append(th); });
      head.append(tr); table.append(head);
      const body = document.createElement('tbody');
      this.c.profiles.forEach(profile => { const row=document.createElement('tr'); const title=document.createElement('th'); title.scope='row';title.textContent=profile.name;row.append(title);profile.points.forEach(point=>{const td=document.createElement('td');td.textContent=point;row.append(td);});body.append(row); });
      table.append(body);host.append(table);
      const list=document.createElement('ol');this.c.questions.forEach(q=>{const li=document.createElement('li');li.textContent=q.text;list.append(li);});host.append(list);
    }
    render(focus) {
      this.el('result-panel').hidden = true;
      this.el('question-panel').hidden = false;
      const q=this.c.questions[this.index];
      this.el('step').textContent=this.fill('step',{n:this.index+1,total:this.c.questions.length});
      this.querySelector('progress').value=this.index;
      this.el('question').textContent=q.text;
      this.el('help').textContent=q.help;
      this.el('important').checked=this.weights[this.index]===2;
      this.el('back').disabled=this.index===0;
      const options=this.querySelector('.mv-answers'); options.replaceChildren();
      for(let i=0;i<4;i++){const b=document.createElement('button');b.type='button';b.className='mv-answer';b.dataset.answer=i;b.textContent=this.label('answer'+i);b.setAttribute('aria-pressed',String(this.answers[this.index]===i));options.append(b);}
      if(focus){this.el('question').focus({preventScroll:true});this.el('question-panel').scrollIntoView({block:'start',behavior:'auto'});}
    }
    answer(value) {
      this.answers[this.index]=value;
      this.index++;
      if(this.index<this.c.questions.length)this.render(true);else this.result();
    }
    result() {
      const count=this.answers.filter(a=>a!==null).length;
      this.el('question-panel').hidden=true;this.el('result-panel').hidden=false;
      this.el('results').replaceChildren();this.el('share-status').textContent='';
      this.el('result-context').textContent=this.fill('context',{n:count});
      const scores=this.c.profiles.map((p,i)=>{
        let difference=0,total=0;
        this.answers.forEach((a,j)=>{if(a!==null){difference+=Math.abs(a-p.points[j])*this.weights[j];total+=this.weights[j];}});
        return {...p,id:i,score:total?Math.round(100*(1-difference/(3*total))):0};
      }).sort((a,b)=>b.score-a.score);
      this.scores=scores;
      const winners=count?scores.filter(p=>p.score===scores[0].score):[];
      this.el('result-title').textContent=!count?this.label('none_title'):winners.length>1?this.label('tie_title'):scores[0].title;
      this.el('result-description').textContent=!count?this.label('none_description'):winners.length>1?this.label('tie_description')+' '+winners.map(p=>p.name).join(' · '):scores[0].description;
      if(count)scores.forEach(p=>{const row=document.createElement('div');row.className='mv-result-row';const line=document.createElement('div');const name=document.createElement('span');name.textContent=p.name;const percent=document.createElement('span');percent.textContent=p.score+' %';line.append(name,percent);const bar=document.createElement('div');bar.className='mv-bar';bar.setAttribute('aria-hidden','true');const fill=document.createElement('span');fill.style.width=p.score+'%';bar.append(fill);row.append(line,bar);this.el('results').append(row);});
      const important=this.c.questions.filter((_,i)=>this.weights[i]===2 && this.answers[i]!==null).map(q=>q.text);
      this.el('result-reasons').textContent=count?(important.length?this.label('reason')+important.join(' '):this.label('no_reason')):'';
      this.el('share').hidden=!count;
      this.el('envelope').hidden=!count || !this.rewardAvailable();
      this.el('envelope-intro').textContent=this.label(this.c.rewardMode==='preview'?'demo_intro':'active_intro');
      this.el('reward').hidden=true;this.el('open-envelope').hidden=false;this.el('code-status').textContent='';
      this.el('result-title').focus({preventScroll:true});this.el('result-panel').scrollIntoView({block:'start',behavior:'auto'});
    }
    rewardAvailable() {
      if(this.c.rewardMode==='preview')return true;
      if(this.c.rewardMode!=='active')return false;
      const start=Date.parse(this.c.starts),end=Date.parse(this.c.ends),now=Date.now();
      return this.codes().length>0 && Boolean(this.c.terms?.trim()) && Number.isFinite(start) && Number.isFinite(end) && start<end && now>=start && now<end;
    }
    codes(){return (this.c.codes||'').split(/\r?\n/).map(s=>s.trim()).filter(Boolean);}
    openEnvelope() {
      if(!this.rewardAvailable()){this.el('envelope-intro').textContent=this.label('expired');this.el('open-envelope').hidden=true;return;}
      const demo=this.c.rewardMode==='preview';
      if(!demo && !this.code){const pool=this.codes();const random=new Uint32Array(1);crypto.getRandomValues(random);this.code=pool[Math.floor((random[0]/4294967296)*pool.length)];}
      this.el('code-label').textContent=demo?'':this.label('code_label');
      this.el('code').textContent=demo?this.label('demo_code'):this.code;
      this.el('terms').textContent=demo?this.label('demo_terms'):this.c.terms;
      this.el('copy-code').hidden=demo;
      this.el('reward').hidden=false;this.el('open-envelope').hidden=true;
    }
    async copy(text,status,isCode=false) {
      try { await navigator.clipboard.writeText(text);status.textContent=this.label(isCode?'copied_code':'copied'); }
      catch { status.textContent=this.label('copy_fail')+' '+text; }
    }
    async share() {
      const winners=this.scores.filter(p=>p.score===this.scores[0].score);
      const text=this.fill('share_text',{name:winners.map(p=>p.name).join(' / '),score:this.scores[0].score});
      const url=new URL(location.href);url.hash='matval-kompass';
      if(url.searchParams.get('view')==='matvalet')url.searchParams.set('preview_theme_id',this.c.themeId);
      for(const key of [...url.searchParams.keys()])if(!['preview_theme_id','view'].includes(key))url.searchParams.delete(key);
      if(navigator.share){try{await navigator.share({title:'Gröna gårdar · Matvalet 2026',text,url:url.href});return;}catch(e){if(e.name==='AbortError')return;}}
      await this.copy(text+' '+url.href,this.el('share-status'));
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
